

export async function LoginUser(app, data, password, isCred = false) {
  const response = await app.request.login(data, password, isCred);
  console.log("response", response);
  const msg = response.msg;
  if (msg !== 'SUCCESS') return showLoginError(app, msg);
  const userData = response.data;
  app.userData = userData;
  await app.afterLoggedIn(data);
  if (userLoggedIn(userData)) {
    app.cache.setCache('login', {data: data, token: userData.token});
  }
}

export async function SetNew2FA(app, data, secret) {
  const response = await app.request.setNew2FA(data, secret);
  console.log("response", response);
  const msg = response.msg;
  const isSuccess = msg === 'SUCCESS';
  if (!isSuccess) return showLoginError(app, msg);
  return isSuccess;
}

export async function Verify2FA(app, data, code) {
  const response = await app.request.verify2FA(data, code);
  console.log("response", response);
  const msg = response.msg;
  const isSuccess = msg === 'SUCCESS';
  // const isSuccess = response.ok;
  if (!isSuccess) return showLoginError(app, "Failed to verify 2FA");
  return response.data;
}

function showLoginError(app, msg) {
  switch (msg) {
    case 'AUTH_FAILED':
      app.setError('Wrong account or password!');
      break;
    case 'NOT_FOUND':
      app.setError('User not found!');
      break;
    default:
      console.error(msg);
      app.setError('User not found!');
      break;
  }
}

export function haveLoggedIn(gui) {
  const loggedIn = userLoggedIn(gui.record);
  if (loggedIn) return true;
  gui.resVisible = false;
  gui.loginVisible = true;
  gui.renderVisible = false;
  gui.addCameraVisible = false;
  gui.addSunLightVisible = false;
  gui.addAreaLightVisible = false;
  return false;
}

export function userLoggedIn(userData) {
  return (userData && userData.token);
}
